import { IDTypeSeparation } from 'civil-status/constants/id-type-separation';
import { SectionVM } from 'civil-status/view-models/step-form';
import { DateTime } from 'luxon';
import { CODE_NAZIONALITA_ITALIA } from 'shell/components/shared/nationality-list';
import { CODE_STATE_ITALIAN } from 'shell/constants/code-state-italian';
import { ModelEventoDTO } from 'shell/models/act-category-list';

const transformTypeSeparation = (idUsecase: string): string => {
  switch (idUsecase) {
    case '343000':
      return IDTypeSeparation.Accordo;
    case '345000':
      return IDTypeSeparation.NegoziazioneAssistita;
    default:
      return IDTypeSeparation.Provvedimento;
  }
};

export const transformerDatiRico350 = (values?: ModelEventoDTO): SectionVM | undefined => {
  if (!values) {
    return;
  }

  const isForeign =
    Boolean(values.datiEventoMatrimonio?.luogoCelebrazione?.idStato) &&
    values.datiEventoMatrimonio?.luogoCelebrazione?.idStato !== CODE_STATE_ITALIAN &&
    values.datiEventoMatrimonio?.luogoCelebrazione?.idStato !== CODE_NAZIONALITA_ITALIA;

  const isCasaComunale = ['311111', '311121', '312111', '312121', '313111'];

  return {
    dateMarriage: values.datiEventoMatrimonio?.dataEvento
      ? DateTime.fromISO(values.datiEventoMatrimonio?.dataEvento)
      : null,
    isForeign,
    foreign: isForeign
      ? {
          state: {
            id: values.datiEventoMatrimonio?.luogoCelebrazione?.idStato || '',
            value: values.datiEventoMatrimonio?.luogoCelebrazione?.nomeStato || '',
          },
        }
      : undefined,
    italian: !isForeign
      ? isCasaComunale
        ? {
            municipality: {
              id: values?.idComuneRegistrazione || '',
              code: values?.idComuneRegistrazione
                ? Number.parseInt(values?.idComuneRegistrazione, 10)
                : undefined,
              description: values.nomeComuneRegistrazione || '',
              province: values.siglaProvinciaRegistrazione || '',
              idProvince: values.idProvinciaRegistrazione
                ? Number.parseInt(values.idProvinciaRegistrazione, 10)
                : undefined,
            },
          }
        : {
            municipality: values.datiEventoMatrimonio?.luogoCelebrazione?.idComune
              ? {
                  description: values.datiEventoMatrimonio?.luogoCelebrazione?.nomeComune || '',
                  province: values.datiEventoMatrimonio?.luogoCelebrazione?.siglaProvincia || '',
                  code: Number.parseInt(
                    values.datiEventoMatrimonio?.luogoCelebrazione?.idComune || '',
                    10
                  ),
                  id: values.datiEventoMatrimonio?.luogoCelebrazione?.idComune || '',
                  idProvince: Number.parseInt(
                    values.datiEventoMatrimonio?.luogoCelebrazione?.idProvincia || '',
                    10
                  ),
                }
              : undefined,
          }
      : undefined,
    celebratedBy:
      values.datiEventoMatrimonio?.officianteEvento?.cognome ||
      values.datiEventoMatrimonio?.officianteEvento?.nome
        ? `${values.datiEventoMatrimonio?.officianteEvento.cognome || ''} ${
            values.datiEventoMatrimonio?.officianteEvento.nome || ''
          }`
        : undefined,
    typeSeparation: transformTypeSeparation(values.idUsecase || ''),
  };
};
